export default {
  title: {
    en: 'No events',
  },
  text: {
    en: 'Oops, there is no events, try again later',
  },
}
